<template>
    <div>
        <navbar></navbar>
        <div class="container pt-4">
            <img src="/static/logo.png" alt="">
            <div class="accordion" role="tablist">
                <b-card no-body class="mb-1">
                    <b-card-header header-tag="header" class="p-1" role="tab">
                        <b-button block v-b-toggle.accordion-1 variant="info">Mobilizace bederní páteře.mp4</b-button>
                    </b-card-header>
                    <b-collapse id="accordion-1" visible accordion="my-accordion" role="tabpanel">
                        <b-card-body>
                            <video width="320" height="240" controls>
                                <source :src="publicPath+'video/Mobilizace bederní páteře.mp4'" type="video/mp4">
                            </video>
                        </b-card-body>
                    </b-collapse>
                </b-card>
        
                <b-card no-body class="mb-1">
                    <b-card-header header-tag="header" class="p-1" role="tab">
                        <b-button block v-b-toggle.accordion-2 variant="info">Mobilizace hrudní páteře - 8 x.mp4</b-button>
                    </b-card-header>
                    <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel">
                        <b-card-body>
                            <video width="320" height="240" controls>
                                <source :src="publicPath+'video/Mobilizace hrudní páteře - 8 x.mp4'" type="video/mp4">
                            </video>
                        </b-card-body>
                    </b-collapse>
                </b-card>
    
                <b-card no-body class="mb-1">
                    <b-card-header header-tag="header" class="p-1" role="tab">
                        <b-button block v-b-toggle.accordion-3 variant="info">Mobilizace kyčlí č. 1 - 8 x na každou stranu.mp4</b-button>
                    </b-card-header>
                    <b-collapse id="accordion-3" accordion="my-accordion" role="tabpanel">
                        <b-card-body>
                            <video width="320" height="240" controls>
                                <source :src="publicPath+'video/Mobilizace kyčlí č. 1 - 8 x na každou stranu.mp4'" type="video/mp4">
                            </video>
                        </b-card-body>
                    </b-collapse>
                </b-card>
    
                <b-card no-body class="mb-1">
                    <b-card-header header-tag="header" class="p-1" role="tab">
                        <b-button block v-b-toggle.accordion-4 variant="info">Mobilizace kyčlí č. 2 - 8 x na každou nohu, minimální pohyb pánve.mp4</b-button>
                    </b-card-header>
                    <b-collapse id="accordion-4" accordion="my-accordion" role="tabpanel">
                        <b-card-body>
                            <video width="320" height="240" controls>
                                <source :src="publicPath+'video/Mobilizace kyčlí č. 2 - 8 x na každou nohu, minimální pohyb pánve.mp4'" type="video/mp4">
                            </video>
                        </b-card-body>
                    </b-collapse>
                </b-card>
    
                <b-card no-body class="mb-1">
                    <b-card-header header-tag="header" class="p-1" role="tab">
                        <b-button block v-b-toggle.accordion-5 variant="info">Mobilizace kyčlí č. 3 - 8 x.mp4</b-button>
                    </b-card-header>
                    <b-collapse id="accordion-5" accordion="my-accordion" role="tabpanel">
                        <b-card-body>
                            <video width="320" height="240" controls>
                                <source :src="publicPath+'video/Mobilizace kyčlí č. 3 - 8 x.mp4'" type="video/mp4">
                            </video>
                        </b-card-body>
                    </b-collapse>
                </b-card>
    
                <b-card no-body class="mb-1">
                    <b-card-header header-tag="header" class="p-1" role="tab">
                        <b-button block v-b-toggle.accordion-6 variant="info">Mobilizace ramenního kloubu č. 1 - 8 x na každou stranu.mp4</b-button>
                    </b-card-header>
                    <b-collapse id="accordion-6" accordion="my-accordion" role="tabpanel">
                        <b-card-body>
                            <video width="320" height="240" controls>
                                <source :src="publicPath+'video/Mobilizace ramenního kloubu č. 1 - 8 x na každou stranu.mp4'" type="video/mp4">
                            </video>
                        </b-card-body>
                    </b-collapse>
                </b-card>
    
                <b-card no-body class="mb-1">
                    <b-card-header header-tag="header" class="p-1" role="tab">
                        <b-button block v-b-toggle.accordion-7 variant="info">Mobilizace ramenního kloubu č. 2 - 8 x na každou paži.mp4</b-button>
                    </b-card-header>
                    <b-collapse id="accordion-7" accordion="my-accordion" role="tabpanel">
                        <b-card-body>
                            <video width="320" height="240" controls>
                                <source :src="publicPath+'video/Mobilizace ramenního kloubu č. 2 - 8 x na každou paži.mp4'" type="video/mp4">
                            </video>
                        </b-card-body>
                    </b-collapse>
                </b-card>
            </div>
        </div>
    </div>
</template>

<script>
    import Navbar from "../components/navbar";
    export default {
        name: "homepage",
        components: {Navbar},
        data() {
            return {
                data: [],
                publicPath: process.env.BASE_URL
            }
        },
        methods: {
        
        },
        computed: {

        }
    }
</script>

<style scoped>

</style>